import { z } from 'zod';
const GGSkip = ({ input, ifSelected, mustBeBlank, mustNotBeBlank, mustBeNA }) => {
    if (input && ifSelected.includes(input) && mustBeBlank?.some((item) => item)) {
        return true;
    }
    if (input && ifSelected.includes(input) && mustNotBeBlank?.some((item) => !item)) {
        return true;
    }
    if (input && ifSelected.includes(input) && mustBeNA?.some((item) => item !== '-')) {
        return true;
    }
};
export const sectionGGSkipPatterns = ({ input, ctx, version: _ }) => {
    const payload = input;
    // GG-skip pattern-5520 (a) If GG0170I1=[07,09,10,88], then GG0170J1, GG0170K1, and GG0170L1 must equal [^].
    if (GGSkip({
        input: payload?.gg0170i1,
        ifSelected: ['07', '09', '10', '88'],
        mustBeBlank: [payload?.gg0170j1, payload?.gg0170k1, payload?.gg0170l1],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5520 (a) If GG0170I1 is 07, 09 ,10 , or 88, then GG0170J1, GG0170K1, and GG0170L1 must be empty',
            path: [],
        });
    }
    // GG-skip pattern-5520 (b) If GG0170I1=[06,05,04,03,02,01], then GG0170J1, GG0170K1, and GG0170L1 must not equal [^].
    if (GGSkip({
        input: payload?.gg0170i1,
        ifSelected: ['06', '05', '04', '03', '02', '01'],
        mustNotBeBlank: [payload?.gg0170j1, payload?.gg0170k1, payload?.gg0170l1],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5520 (b) If GG0170I1 is 06, 05, 04, 03 , 02, 01, then GG0170J1, GG0170K1, and GG0170L1 must NOT be empty.',
            path: [],
        });
    }
    // GG-skip pattern-5520 (c) If GG0170I1=[-], then GG0170J1, GG0170K1, and GG0170L1 must equal [-].
    if (GGSkip({
        input: payload?.gg0170i1,
        ifSelected: ['-'],
        mustBeNA: [payload?.gg0170j1, payload?.gg0170k1, payload?.gg0170l1],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-5520 (c) If GG0170I1 'No Information Available', then GG0170J1, GG0170K1, and GG0170L1 must be answered as 'No Information Available'.",
            path: [],
        });
    }
    // GG-skip pattern-5530 (a) If GG0170I3=[07,09,10,88], then GG0170J3, GG0170K3, and GG0170L3 must equal [^].
    if (GGSkip({
        input: payload?.gg0170i3,
        ifSelected: ['07', '09', '10', '88'],
        mustBeBlank: [payload?.gg0170j3, payload?.gg0170k3, payload?.gg0170l3],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5530 (a) If GG0170I3 is 07, 09 ,10 , or 88, then GG0170J3, GG0170K3, and GG0170L3 must be empty',
            path: [],
        });
    }
    // GG-skip pattern-5530 (b) If GG0170I3=[06,05,04,03,02,01], then GG0170J3, GG0170K3, and GG0170L3 must not equal [^].
    if (GGSkip({
        input: payload?.gg0170i3,
        ifSelected: ['06', '05', '04', '03', '02', '01'],
        mustNotBeBlank: [payload?.gg0170j3, payload?.gg0170k3, payload?.gg0170l3],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5530 (b) If GG0170I3 is 06, 05, 04, 03 , 02, 01, then GG0170J3, GG0170K3, and GG0170L3 must NOT be empty.',
            path: [],
        });
    }
    // GG-skip pattern-5530 (c) If GG0170I3=[-], then GG0170J3, GG0170K3, and GG0170L3 must equal [-].
    if (GGSkip({
        input: payload?.gg0170i3,
        ifSelected: ['-'],
        mustBeNA: [payload?.gg0170j3, payload?.gg0170k3, payload?.gg0170l3],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-5530 (c) If GG0170I3 'No Information Available', then GG0170J3, GG0170K3, and GG0170L3 must be answered as 'No Information Available'.",
            path: [],
        });
    }
    // GG-skip pattern-5540 (a) If GG0170I4=[07,09,10,88], then GG0170J4 and GG0170L4 must equal [^].
    if (GGSkip({
        input: payload?.gg0170i4,
        ifSelected: ['07', '09', '10', '88'],
        mustBeBlank: [payload?.gg0170j4, payload?.gg0170l4],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5540 (a) If GG0170I4 is 07, 09 ,10 , or 88, then GG0170J4 and GG0170L4 must be empty',
            path: [],
        });
    }
    // GG-skip pattern-5540 (b) If GG0170I4=[06,05,04,03,02,01], then GG0170J4 and GG0170L4 must not equal [^].
    if (GGSkip({
        input: payload?.gg0170i4,
        ifSelected: ['06', '05', '04', '03', '02', '01'],
        mustNotBeBlank: [payload?.gg0170j4, payload?.gg0170l4],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5540 (b) If GG0170I4 is 06, 05, 04, 03 , 02, 01, then GG0170J4 and GG0170L4 must NOT be empty.',
            path: [],
        });
    }
    // GG-skip pattern-5540 (c) If GG0170I4=[-], then GG0170J4 and GG0170L4 must equal [-].
    if (GGSkip({
        input: payload?.gg0170i4,
        ifSelected: ['-'],
        mustBeNA: [payload?.gg0170j4, payload?.gg0170l4],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-5540 (c) If GG0170I4 'No Information Available', then GG0170J4 and GG0170L4 must be answered as 'No Information Available'.",
            path: [],
        });
    }
    // GG-skip pattern-5550 (a) If GG0170M1=[07,09,10,88], then GG0170N1 must equal [^].
    if (GGSkip({
        input: payload?.gg0170m1,
        ifSelected: ['07', '09', '10', '88'],
        mustBeBlank: [payload?.gg0170n1],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5550 (a) If GG0170M1 is 07, 09 ,10 , or 88, then GG0170N1 must be empty',
            path: [],
        });
    }
    // GG-skip pattern-5550 (b) If GG0170M1=[06,05,04,03,02,01], then GG0170N1 must not equal [^].
    if (GGSkip({
        input: payload?.gg0170m1,
        ifSelected: ['06', '05', '04', '03', '02', '01'],
        mustNotBeBlank: [payload?.gg0170n1],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5550 (b) If GG0170M1 is 06, 05, 04, 03 , 02, 01, then GG0170N1 must NOT be empty.',
            path: [],
        });
    }
    // GG-skip pattern-5550 (c) If GG0170M1=[-], then GG0170N1 must equal [-].
    if (GGSkip({
        input: payload?.gg0170m1,
        ifSelected: ['-'],
        mustBeNA: [payload?.gg0170n1],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-5550 (c) If GG0170M1 'No Information Available', then GG0170N1 must be answered as 'No Information Available'.",
            path: [],
        });
    }
    // GG-skip pattern-5560 (a) If GG0170M3=[07,09,10,88], then GG0170N3 must equal [^].
    if (GGSkip({
        input: payload?.gg0170m3,
        ifSelected: ['07', '09', '10', '88'],
        mustBeBlank: [payload?.gg0170n3],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5560 (a) If GG0170M3 is 07, 09 ,10 , or 88, then GG0170N3 must be empty',
            path: [],
        });
    }
    // GG-skip pattern-5560 (b) If GG0170M3=[06,05,04,03,02,01], then GG0170N3 must not equal [^].
    if (GGSkip({
        input: payload?.gg0170m3,
        ifSelected: ['06', '05', '04', '03', '02', '01'],
        mustNotBeBlank: [payload?.gg0170n3],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5560 (b) If GG0170M3 is 06, 05, 04, 03 , 02, 01, then GG0170N3 must NOT be empty.',
            path: [],
        });
    }
    // GG-skip pattern-5560 (c) If GG0170M3=[-], then GG0170N3 must equal [-].
    if (GGSkip({
        input: payload?.gg0170m3,
        ifSelected: ['-'],
        mustBeNA: [payload?.gg0170n3],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-5560 (c) If GG0170M3 'No Information Available', then GG0170N3 must be answered as 'No Information Available'.",
            path: [],
        });
    }
    // GG-skip pattern-5570 (a) If GG0170M4=[07,09,10,88], then GG0170N4 must equal [^].
    if (GGSkip({
        input: payload?.gg0170m4,
        ifSelected: ['07', '09', '10', '88'],
        mustBeBlank: [payload?.gg0170n4],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5570 (a) If GG0170M4 is 07, 09 ,10 , or 88, then GG0170N4 must be empty',
            path: [],
        });
    }
    // GG-skip pattern-5570 (b) If GG0170M4=[06,05,04,03,02,01], then GG0170N4 must not equal [^].
    if (GGSkip({
        input: payload?.gg0170m4,
        ifSelected: ['06', '05', '04', '03', '02', '01'],
        mustNotBeBlank: [payload?.gg0170n4],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5570 (b) If GG0170M4 is 06, 05, 04, 03 , 02, 01, then GG0170N4 must NOT be empty.',
            path: [],
        });
    }
    // GG-skip pattern-5570 (c) If GG0170M4=[-], then GG0170N4 must equal [-].
    if (GGSkip({
        input: payload?.gg0170m4,
        ifSelected: ['-'],
        mustBeNA: [payload?.gg0170n4],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-5570 (c) If GG0170M4 'No Information Available', then GG0170N4 must be answered as 'No Information Available'.",
            path: [],
        });
    }
    // GG-skip pattern-5580 (a) If GG0170N1=[07,09,10,88,^], then GG0170O1 must equal [^].
    if (GGSkip({
        input: payload?.gg0170n1,
        ifSelected: ['07', '09', '10', '88'],
        mustBeBlank: [payload?.gg0170o1],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5580 (a) If GG0170N1 is 07, 09 ,10 , or 88, then GG0170O1 must be empty',
            path: [],
        });
    }
    // GG-skip pattern-5580 (b) If GG0170N1=[06,05,04,03,02,01], then GG0170O1 must not equal [^].
    if (GGSkip({
        input: payload?.gg0170n1,
        ifSelected: ['06', '05', '04', '03', '02', '01'],
        mustNotBeBlank: [payload?.gg0170o1],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5580 (b) If GG0170N1 is 06, 05, 04, 03 , 02, 01, then GG0170O1 must NOT be empty.',
            path: [],
        });
    }
    // GG-skip pattern-5580 (c) If GG0170N1=[-], then GG0170O1 must equal [-].
    if (GGSkip({
        input: payload?.gg0170n1,
        ifSelected: ['-'],
        mustBeNA: [payload?.gg0170o1],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-5580 (c) If GG0170N1 'No Information Available', then GG0170O1 must be answered as 'No Information Available'.",
            path: [],
        });
    }
    // GG-skip pattern-5590 (a) If GG0170N3=[07,09,10,88,^], then GG0170O3 must equal [^].
    if (GGSkip({
        input: payload?.gg0170n3,
        ifSelected: ['07', '09', '10', '88'],
        mustBeBlank: [payload?.gg0170o3],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5590 (a) If GG0170N3 is 07, 09 ,10 , or 88, then GG0170O3 must be empty',
            path: [],
        });
    }
    // GG-skip pattern-5590 (b) If GG0170N3=[06,05,04,03,02,01], then GG0170O3 must not equal [^].
    if (GGSkip({
        input: payload?.gg0170n3,
        ifSelected: ['06', '05', '04', '03', '02', '01'],
        mustNotBeBlank: [payload?.gg0170o3],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5590 (b) If GG0170N3 is 06, 05, 04, 03 , 02, 01, then GG0170O3 must NOT be empty.',
            path: [],
        });
    }
    // GG-skip pattern-5590 (c) If GG0170N3=[-], then GG0170O3 must equal [-].
    if (GGSkip({
        input: payload?.gg0170n3,
        ifSelected: ['-'],
        mustBeNA: [payload?.gg0170o3],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-5590 (c) If GG0170N3 'No Information Available', then GG0170O3 must be answered as 'No Information Available'.",
            path: [],
        });
    }
    // GG-skip pattern-7020 (a) If GG0170Q1=[0], then the following items must be equal to [^]:  GG0170R1, GG0170RR1, GG0170S1, GG0170SS1.
    if (GGSkip({
        input: payload?.gg0170q1,
        ifSelected: ['0'],
        mustBeBlank: [payload?.gg0170r1, payload?.gg0170rr1, payload?.gg0170s1, payload?.gg0170ss1],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-7020 (a) If GG0170Q1 is 'No' then items from GG0170R1 through GG0170SS1 must be empty",
            path: [],
        });
    }
    // GG-skip pattern-7020 (b) If GG0170Q1=[1], then the following items must not be equal to [^]:  GG0170R1, GG0170RR1, GG0170S1, GG0170SS1.
    if (GGSkip({
        input: payload?.gg0170q1,
        ifSelected: ['1'],
        mustNotBeBlank: [payload?.gg0170r1, payload?.gg0170rr1, payload?.gg0170s1, payload?.gg0170ss1],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-7020 (b) If GG0170Q1 is 'Yes', then items from GG0170R1 through GG0170SS1 must NOT be empty.",
            path: [],
        });
    }
    // GG-skip pattern-7020 (c) If GG0170Q1=[-], then the following items must be equal to [-]:  GG0170R1, GG0170RR1, GG0170S1, GG0170SS1.
    if (GGSkip({
        input: payload?.gg0170q1,
        ifSelected: ['-'],
        mustBeNA: [payload?.gg0170r1, payload?.gg0170rr1, payload?.gg0170s1, payload?.gg0170ss1],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-7020 (c) If GG0170Q1 'No Information Available', then items from GG0170R1 through GG0170SS1 must be answered as 'No Information Available'.",
            path: [],
        });
    }
    // GG-skip pattern-5620 (a) If GG0170Q3=[0], then the following items must be equal to [^]:  GG0170R3, GG0170RR3, GG0170S1, GG0170SS1.
    if (GGSkip({
        input: payload?.gg0170q3,
        ifSelected: ['0'],
        mustBeBlank: [payload?.gg0170r3, payload?.gg0170rr3, payload?.gg0170s3, payload?.gg0170ss3],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5520 (a) If GG0170Q3 is 0 then items from GG0170R3 through GG0170SS3 must be empty',
            path: [],
        });
    }
    // GG-skip pattern-5620 (b) If GG0170Q3=[1], then the following items must not be equal to [^]: GG0170R3, GG0170RR3, GG0170S3, GG0170SS3.
    if (GGSkip({
        input: payload?.gg0170q3,
        ifSelected: ['1'],
        mustNotBeBlank: [payload?.gg0170r3, payload?.gg0170rr3, payload?.gg0170s3, payload?.gg0170ss3],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5620 (b) If GG0170Q3 is 01, then items from GG0170R3 through GG0170SS3 must NOT be empty.',
            path: [],
        });
    }
    // GG-skip pattern-5620 (c) If GG0170Q3=[-], then the following items must be equal to [-]: GG0170R3, GG0170RR3, GG0170S3, GG0170SS3.
    if (GGSkip({
        input: payload?.gg0170q3,
        ifSelected: ['-'],
        mustBeNA: [payload?.gg0170r3, payload?.gg0170rr3, payload?.gg0170s3, payload?.gg0170ss3],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-5620 (c) If GG0170Q3 'No Information Available', then items from GG0170R3 through GG0170SS3 must be answered as 'No Information Available'.",
            path: [],
        });
    }
    // GG-skip pattern-5620 (a) If GG0170Q4=[0], then GG0170R4 must be equal to [^].
    if (GGSkip({
        input: payload?.gg0170q4,
        ifSelected: ['0'],
        mustBeBlank: [payload?.gg0170r4],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5620 (a) If GG0170Q4=[0], then GG0170R4 must be empty.',
            path: [],
        });
    }
    // GG-skip pattern-5620 (b) If GG0170Q4=[1], then GG0170R4 must not be equal to [^].
    if (GGSkip({
        input: payload?.gg0170q4,
        ifSelected: ['1'],
        mustNotBeBlank: [payload?.gg0170r4],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '-5620 (b) If GG0170Q4=[1], then GG0170R4 must NOT be empty.',
            path: [],
        });
    }
    // GG-skip pattern-5620 (c) If GG0170Q1=[-], then the following items must be equal to [-]:  GG0170R1, GG0170RR1, GG0170S1, GG0170SS1.
    if (GGSkip({
        input: payload?.gg0170q4,
        ifSelected: ['-'],
        mustBeNA: [payload?.gg0170r4],
    })) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "-5620 (c) If GG0170Q4 'No Information Available', then GG0170R4 must be answered as 'No Information Available'.",
            path: [],
        });
    }
};
// GG-skip pattern-5520
// (a) If GG0170I1=[07,09,10,88], then GG0170J1, GG0170K1, and GG0170L1 must equal [^].
// (b) If GG0170I1=[06,05,04,03,02,01], then GG0170J1, GG0170K1, and GG0170L1 must not equal [^].
// (c) If GG0170I1=[-], then GG0170J1, GG0170K1, and GG0170L1 must equal [-].
// GG-skip pattern-5530
// (a) If GG0170I3=[07,09,10,88], then GG0170J3, GG0170K3, and GG0170L3 must equal [^].
// (b) If GG0170I3=[06,05,04,03,02,01], then GG0170J3, GG0170K3, and GG0170L3 must not equal [^].
// (c) If GG0170I3=[-], then GG0170J3, GG0170K3, and GG0170L3 must equal [-].
// GG-skip pattern-5540
// (a) If GG0170I4=[07,09,10,88], then GG0170J4 and GG0170L4 must equal [^].
// (b) If GG0170I4=[06,05,04,03,02,01], then GG0170J4 and GG0170L4 must not equal [^].
// (c) If GG0170I4=[-], then GG0170J4 and GG0170L4 must equal [-].
// GG-skip pattern-5550
// (a) If GG0170M1=[07,09,10,88], then GG0170N1 must equal [^].
// (b) If GG0170M1=[06,05,04,03,02,01], then GG0170N1 must not equal [^].
// (c) If GG0170M1=[-], then GG0170N1 must equal [-].
// GG-skip pattern-5560
// (a) If GG0170M3=[07,09,10,88], then GG0170N3 must equal [^].
// (b) If GG0170M3=[06,05,04,03,02,01], then GG0170N3 must not equal [^].
// (c) If GG0170M3=[-], then GG0170N3 must equal [-].
// GG-skip pattern-5570
// (a) If GG0170M4=[07,09,10,88], then GG0170N4 must equal [^].
// (b) If GG0170M4=[06,05,04,03,02,01], then GG0170N4 must not equal [^].
// (c) If GG0170M4=[-], then GG0170N4 must equal [-].
// GG-skip pattern-5580
// (a) If GG0170N1=[07,09,10,88,^], then GG0170O1 must equal [^].
// (b) If GG0170N1=[06,05,04,03,02,01], then GG0170O1 must not equal [^].
// (c) If GG0170N1=[-], then GG0170O1 must equal [-].
// GG-skip pattern-5590
// (a) If GG0170N3=[07,09,10,88,^], then GG0170O3 must equal [^].
// (b) If GG0170N3=[06,05,04,03,02,01], then GG0170O3 must not equal [^].
// (c) If GG0170N3=[-], then GG0170O3 must equal [-].
// GG-skip pattern-5600 ***THIS EDIT WAS DELETED IN V3.01.0***
// GG-skip pattern-7020
// (a) If GG0170Q1=[0], then the following items must be equal to [^]:  GG0170R1, GG0170RR1, GG0170S1, GG0170SS1.
// (b) If GG0170Q1=[1], then the following items must not be equal to [^]:  GG0170R1, GG0170RR1, GG0170S1, GG0170SS1.
// (c) If GG0170Q1=[-], then the following items must be equal to [-]:  GG0170R1, GG0170RR1, GG0170S1, GG0170SS1.
// GG-skip pattern-5610
// (a) If GG0170Q3=[0], then the following items must be equal to [^]:  GG0170R3, GG0170RR3, GG0170S3, GG0170SS3.
// (b) If GG0170Q3=[1], then the following items must not be equal to [^]:  GG0170R3, GG0170RR3, GG0170S3, GG0170SS3.
// (c) If GG0170Q3=[-], then the following items must be equal to [-]: GG0170R3, GG0170RR3, GG0170S3, GG0170SS3.
// GG-skip pattern-5620
// (a) If GG0170Q4=[0], then GG0170R4 must be equal to [^].
// (b) If GG0170Q4=[1], then GG0170R4 must not be equal to [^].
// (c) If GG0170Q4=[-], then GG0170R4 must be equal to [-].
